module.exports = __webpack_public_path__ + "img/red-circle-table-1.e974c6b0.png";